module.exports = __webpack_public_path__ + "static/media/FK.9144425b.svg";